import { EventHelper } from "app/helpers/eventHelper";
import type { EventIncidentType } from "app/types/eventType";
//
export class ExtraTimeScoresHelper {
  static displayFullTimeScoreInExtraTimeScores: any = (
    eventIncidents: EventIncidentType[],
    period: string
  ) => {
    const homeScoreFullTime = EventHelper.getHomeScore(
      eventIncidents[0]["scoreDetails"]
    );
    const awayScoreFullTime = EventHelper.getAwayScore(
      eventIncidents[0]["scoreDetails"]
    );
    const scoreFullTime = (
      <span className="extra-time-ft-score">
        FT&nbsp;({homeScoreFullTime} - {awayScoreFullTime})
      </span>
    );
    return scoreFullTime;
  };
}
